import React from 'react';
import { IInvestorFavorite } from '../models/dashboardModels';
import { getFavoritesSummaryLabel, getNamedFavorites } from '../adapters/favoritesAdapter';
import { getIntentSignal } from '../adapters/intentSignalAdapter';
import IntentSignalCard from './IntentSignalCard';

interface IntentSignalsCellProps {
  favorites: IInvestorFavorite[] | undefined;
  visitDate: string;
  visitTime: string;
  status: string;
  onViewFavorites: () => void;
  isPreSale?: boolean;
}

const IntentSignalsCell: React.FC<IntentSignalsCellProps> = ({
  favorites,
  visitDate,
  visitTime,
  status,
  onViewFavorites,
  isPreSale = false,
}) => {
  const namedFavorites = getNamedFavorites(favorites);
  const hasFavorites = namedFavorites.length > 0;
  const signal = getIntentSignal(
    visitDate,
    visitTime,
    status,
    hasFavorites,
    isPreSale,
  );

  if (!signal && !hasFavorites) {
    return (
      <span className="text-muted small">
        Sin favoritos guardados. Tratamiento estándar de agenda.
      </span>
    );
  }

  return (
    <>
      {signal && (
        <IntentSignalCard signal={signal} hasFavorites={hasFavorites} />
      )}
      {hasFavorites && (
        <div className="small">
          Guardó{' '}
          <span
            className="text-danger font-weight-bold"
            style={{ textDecoration: 'underline', cursor: 'pointer' }}
            role="button"
            onClick={onViewFavorites}
          >
            {getFavoritesSummaryLabel(favorites)}
          </span>
        </div>
      )}
    </>
  );
};

export default IntentSignalsCell;
